import React from 'react';
import { Table, Empty, Button, Tag, Form, Input, Tooltip, DatePicker, Icon, Select } from 'antd';
import { PENDIENTE, CERRADO } from '../../../../common/types/fondoFijoDetalleEstadoType';
import { FORMAT_2DECIMALS, GREATER_THAN_ZERO } from '../../../../common/types/regularExpresionType';
import moment from 'moment';
const { Option } = Select;
export default function DetalleResultList(props) {
    const renderColor = (row) => {
        // if (row.idFondoFijoDetalleEstado === PENDIENTE)
        //     return 'gold';
        // if (row.idFondoFijoDetalleEstado === CERRADO)
        //     return 'orange';
    };
    return (
        <div>
            <Table
                className={'table-fondo-fijo-detalle'}
                size="small"
                style={{ overflowX: 'auto' }}
                dataSource={props.source}
                pagination={{
                    pageSize: 10,
                    showTotal: (total) => `${total} Registro(s) encontrado(s).`
                }}
                title={() => (
                    <div style={{ width: '100%', textAlign: "right" }}>
                        <div className="custom-options">
                            <Button
                                icon="plus"
                                type="link"
                                onClick={() => {
                                    
                                    props.onAgregarDetalle(
                                        props.form.setFieldsValue,
                                        props.form.getFieldValue
                                    )
                                }}
                                loading={props.loadingNew}
                            >
                                Agregar
                            </Button>
                        </div>
                    </div>
                )}
                columns={[
                    {
                        title: 'Opciones',
                        key: 'options',
                        align: 'center',
                        width: "80px",
                        fixed: 'left',
                        render: (value, row) => (
                            <span>
                                <div className="custom-options">
                                    <Tooltip placement="top" title="Anular">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onAnular(row)}
                                            disabled={row.idFondoFijoEstado === PENDIENTE ? false : true}
                                        />
                                    </Tooltip>
                                    <Tooltip placement="top" title="Eliminar">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => props.onEliminar(value)}
                                        />
                                    </Tooltip>
                                </div>
                            </span>
                        )
                    },
                    {
                        title: 'Fecha Entrega',
                        dataIndex: 'fechaEntrega',
                        key: 'fechaEntrega',
                        align: 'center',
                        width: 120,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrFechaEntrega[${row.identifier}]`, {
                                        initialValue: moment(value, 'DD/MM/YYYY'),
                                        rules: [{
                                            required: true,
                                            message: "Formato (dd/mm/yyyy)"
                                        }]
                                    })(
                                        <DatePicker
                                            className="first-input"
                                            placeholder="dd/mm/yyyy"
                                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            format="DD/MM/YYYY"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Empleado',
                        dataIndex: 'idEmpleado',
                        key: 'idEmpleado',
                        width: 300,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrEmpleado[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Empleado"}
                                            optionFilterProp="children"
                                        >
                                            {props.empleados.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Registro Contable',
                        dataIndex: 'registroContable',
                        key: 'registroContable',
                        width: 300,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrRegistroContable[${row.identifier}]`, {
                                        initialValue: value,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Registro Contable"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Cuenta Contable',
                        dataIndex: 'idPlanCuenta',
                        key: 'idPlanCuenta',
                        width: 300,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrCuentaContable[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Cuenta Contable"}
                                            optionFilterProp="children"
                                        >
                                            {props.cuentasContable.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Moneda',
                        dataIndex: 'idMoneda',
                        key: 'idMoneda',
                        width: 150,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrMoneda[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Moneda"}
                                            optionFilterProp="children"
                                        >
                                            {props.monedas.map(item => (
                                                <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Monto',
                        dataIndex: 'monto',
                        key: 'monto',
                        width: 150,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrMonto[${row.identifier}]`, {
                                        initialValue: parseFloat(value).toFixed(2),
                                        rules: [{
                                            required: true,
                                            pattern: new RegExp(FORMAT_2DECIMALS),
                                            message: "Formato (0.00)"
                                        },
                                        {
                                            required: true,
                                            pattern: new RegExp(GREATER_THAN_ZERO),
                                            message: "Monto debe ser mayor a 0"
                                        }]
                                    })(
                                        <Input
                                            className="text-right"
                                            onKeyPress={global.onKeyPressDecimals}
                                            placeholder="Ingresar Monto"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    },
                    {
                        title: 'Descripcion',
                        dataIndex: 'descripcion',
                        key: 'descripcion',
                        width: 300,
                        render: (value, row) => {
                            return (
                                <Form.Item>
                                    {props.onGetFieldDecorator(`arrDescripcion[${row.identifier}]`, {
                                        initialValue: value,
                                        validateTrigger: ['onBlur'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido',
                                            whitespace: true
                                        }]
                                    })(
                                        <Input
                                            placeholder="Ingresar Descripcion"
                                            autoComplete="off"
                                        />
                                    )}
                                </Form.Item>
                            );
                        }
                    }
                ]}
            />
        </div>
    );
}